import MakePresenter from "presenters/MakePresenter";
import TemplatePresenter from "presenters/TemplatePresenter";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";

export const fmvrAttributes = (make, templateGroup) => {
  return {
    data: {
      attributes: {
        size: "480x270",
        template: {
          type: TemplateGroupPresenter.templateGroupType(templateGroup),
          slug: TemplatePresenter.id(make.template),
          file: MakePresenter.webglFeatureVideo(make),
          position_data: MakePresenter.webglPositionData(make),
          actors: MakePresenter.castings(make).map(({ roleRank, headAsset, jawSvg }) => ({
            rank: roleRank,
            file: headAsset,
            svg: jawSvg,
          })),
        },
      },
      type: "fmvr-requests",
      id: MakePresenter.id(make),
    },
  };
};
